"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_async_call_1 = require("./use-async-call");
var rxjs_1 = require("rxjs");
exports.useAsyncValue = function (fetchValue, volatileArgs) {
    var _a = react_1.useState(null), value = _a[0], setValue = _a[1];
    var _b = react_1.useState(null), pending = _b[0], setPending = _b[1];
    var _c = react_1.useState(null), promise = _c[0], setPromise = _c[1];
    var _d = use_async_call_1.useAsyncCall(function () { return __awaiter(void 0, void 0, void 0, function () {
        var promise, subscription;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (pending) {
                        pending.unsubscribe();
                    }
                    promise = fetchValue();
                    setPromise(promise);
                    subscription = rxjs_1.from(promise).subscribe({
                        next: function (value) { return setValue(value); },
                        error: function () { return subscription.unsubscribe(); }
                    });
                    setPending(subscription);
                    return [4, promise];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); }), fetch = _d[0], fetching = _d[1], error = _d[2];
    react_1.useEffect(function () {
        fetch();
    }, volatileArgs || []);
    var loading = fetching || pending === null;
    return [value, loading, error, promise];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWFzeW5jLXZhbHVlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3VzZS1hc3luYy12YWx1ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtCQUEwQztBQUMxQyxtREFBOEM7QUFDOUMsNkJBQXdDO0FBSzNCLFFBQUEsYUFBYSxHQUFHLFVBQUksVUFBeUIsRUFBRSxZQUFvQjtJQUN0RSxJQUFBLDJCQUE0QyxFQUEzQyxhQUFLLEVBQUUsZ0JBQW9DLENBQUM7SUFDN0MsSUFBQSwyQkFBMkQsRUFBMUQsZUFBTyxFQUFFLGtCQUFpRCxDQUFDO0lBQzVELElBQUEsMkJBQXlELEVBQXhELGVBQU8sRUFBRSxrQkFBK0MsQ0FBQztJQUUxRCxJQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7VUFjSixFQWRLLGFBQUssRUFBRSxnQkFBUSxFQUFFLGFBY3RCLENBQUM7SUFFSCxpQkFBUyxDQUFDO1FBQ04sS0FBSyxFQUFFLENBQUM7SUFDWixDQUFDLEVBQUUsWUFBWSxJQUFJLEVBQUUsQ0FBQyxDQUFDO0lBRXZCLElBQU0sT0FBTyxHQUFHLFFBQVEsSUFBSSxPQUFPLEtBQUssSUFBSSxDQUFDO0lBQzdDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQztBQUM1QyxDQUFDLENBQUMifQ==